const dateUtils = {
  format: (date) => {
    const day = dateUtils.padStart(date.getDate().toString());
    const month = dateUtils.padStart((date.getMonth() + 1).toString());
    const year = date.getFullYear();
    return day + "/" + month + "/" + year;
  },

  format2Service: (date) => {

    date = new Date(date.substring(3, 6) + date.substring(0, 3) + date.substring(6))

    const day = dateUtils.padStart(date.getDate().toString());
    const month = dateUtils.padStart((date.getMonth() + 1).toString());
    const year = date.getFullYear();
    return year + '-' + month + '-' + day + 'T00:00:00'
  },

  formatToChat: (date) => {
    date = new Date(date);

    const day = dateUtils.padStart(date.getDate().toString());
    const month = dateUtils.padStart((date.getMonth() + 1).toString());
    const year = date.getFullYear();
    return year + '%2D' + month + '%2D' + day
  },

  padStart: (text) => {
    if (text.length === 1) {
      text = '0' + text
    }
    return text;
  }
};


export default dateUtils;

